import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ElementRef, Renderer2, Input, OnDestroy, AfterViewInit } from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import { ViewService } from 'src/app/view/view.service';
import { Actions } from '@ngxs/store';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-play-loader',
  templateUrl: './play-loader.component.html',
  styleUrls: ['./play-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlayLoaderComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('circle', { static: true })
  circleRef: ElementRef<HTMLElement>;

  @ViewChild('progressCircle', { static: true })
  progressCircleRef: ElementRef<SVGCircleElement>;

  @ViewChild('progressContainer', { static: true })
  progressContainerRef: ElementRef<SVGCircleElement>;


  ngUnsubscribe = new Subject();


  // ---------- Inputs ----------
  @Input()
  public get percent() {
    return this._percent;
  }
  public set percent(value) {
    if (value == null) {
      return;
    }

    this._percent = value;
    this.setProgress(this.percent);
  }
  private _percent = 0;



  // ---------- Lifecycle ----------
  constructor(
    private renderer: Renderer2,
    private viewService: ViewService,
    private actions: Actions
  ) { }

  ngOnInit() {
    this.initSizeObserver();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngAfterViewInit() {
    this.updateDimensions();
    this.initCircle();
  }

  // ---------- Class Methods ----------
  initSizeObserver() {
    // Listen to view page resize
    const windowResize$ = fromEvent(window, 'resize');
    windowResize$
      .pipe(
        debounceTime(10),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => {
        this.updateDimensions();
      });
  }

  calculateRadius() {
    return this.getCircleWidth() / 2;
  }

  getCircleWidth() {
    return this.circleRef.nativeElement.offsetWidth;
  }

  getRadius() {
    return this.progressCircleRef.nativeElement.r.baseVal.value;
  }

  getCircumference() {
    const radius = this.getRadius();
    return radius * 2 * Math.PI;
  }

  getOffset(percent = 100) {
    const circumference = this.getCircumference();
    return circumference - percent / 100 * circumference;
  }

  setProgress(percent) {
    if (percent >= 100) {
      percent = 100;
    }

    const circumference = this.getCircumference();
    const offset = this.getOffset(percent);

    this.renderer.setStyle(this.progressCircleRef.nativeElement, 'strokeDasharray', `${circumference} ${circumference}`);
    this.renderer.setStyle(this.progressCircleRef.nativeElement, 'strokeDashoffset', `${offset}`);
  }

  initCircle() {

  }

  updateDimensions() {
    const radius = this.calculateRadius();

    this.renderer.setAttribute(this.progressContainerRef.nativeElement, 'width', `${radius * 2}`);
    this.renderer.setAttribute(this.progressContainerRef.nativeElement, 'height', `${radius * 2}`);

    this.renderer.setAttribute(this.progressCircleRef.nativeElement, 'r', `${radius - 6}`);
    this.renderer.setAttribute(this.progressCircleRef.nativeElement, 'cx', `${radius}`);
    this.renderer.setAttribute(this.progressCircleRef.nativeElement, 'cy', `${radius}`);

    const circumference = this.getCircumference();

    this.renderer.setStyle(this.progressCircleRef.nativeElement, 'strokeDasharray', `${circumference} ${circumference}`);
    this.renderer.setStyle(this.progressCircleRef.nativeElement, 'strokeDashoffset', `${circumference}`);
  }





}
